import UIUtils from 'js/lib/UIUtils';
import { getEligibleSourceEntities } from 'js/reducers/selectors';
import { getConnectionOrVendorType } from 'js/lib/ResourceUtils';
import has from 'lodash/has';
import {
  GET_DATA_SOURCE_REQUEST,
  GET_DATA_SOURCES_REQUEST,
  NEX_ORG_SWITCH_REQUEST,
} from 'js/constants/actionTypes';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { isAdminAccess, isManagedResource, isReadOnly } from 'js/lib/ACLUtils';
import DateUtils from 'js/lib/DateUtils';
import { getStatusInfo } from 'new/hooks/adapters/statusInfo';

export const getSourceMeta = (sourceId, state) => {
  const {
    entities: { sources, vendors, users },
    sources: { summaryById },
    paging: { metaInfoById },
  } = state;

  const sourceEntity = sources[sourceId];

  let connectionOrVendorType = getConnectionOrVendorType(
    sourceEntity,
    vendors,
    'source_type',
    'vendor_id',
  );

  return connectionOrVendorType && has(metaInfoById, connectionOrVendorType)
    ? metaInfoById[connectionOrVendorType]
    : null;
};

export function useMySources() {
  const state = useSelector((state: any) => state);
  const {
    sources: { byId, summaryById },
    entities: { vendors, users },
    request,
  } = state;
  const params = useParams();
  const sourceId = UIUtils.extractParamFromURL(params);
  const sources = getEligibleSourceEntities(state);

  const mappedSources = Object.values(sources).map((source) => {
    const readOnly = isReadOnly(source);
    const isManaged = isManagedResource(source);
    const adminAccess = isAdminAccess(source);

    const connectionOrVendorType = getConnectionOrVendorType(
      source,
      vendors,
      'source_type',
      'vendor_id',
    );

    const owner = has(source, 'owner') && has(users, source.owner) ? users[source.owner] : null;

    const summaryData = source && has(summaryById, source.id) ? summaryById[source.id] : null;

    const createdAt = DateUtils.convertDateStringToFormat(source.created_at, 'MMM D, YYYY');
    const nexsetsCount = has(summaryData, 'data_sets') ? summaryData.data_sets : null;
    const description = source.description || ' ';
    const connectionInfo = getSourceMeta(source.id, state);

    let sourceIcon;
    let sourceName;

    if (connectionInfo) {
      sourceIcon = connectionInfo.iconSm;
      sourceName = connectionInfo.name;
    } else {
      sourceName = connectionOrVendorType;
    }

    return {
      ...source,
      readOnly,
      isManaged,
      adminAccess,
      connectionOrVendorType,
      owner,
      nexsetsCount,
      ...summaryData,
      createdAt,
      icon: sourceIcon,
      sourceName,
      description,
      statusInfo: getStatusInfo(source.status),
    };
  });

  return {
    sourceId,
    sources: mappedSources,
    allSources: byId,
    isLoading:
      request[NEX_ORG_SWITCH_REQUEST] ||
      request[GET_DATA_SOURCES_REQUEST] ||
      request[GET_DATA_SOURCE_REQUEST],
  };
}
